import cx from "classnames"

import type { TextFieldProps } from "../.."

import { Label } from "../../../label"
import styles from "../../index.module.css"

export const IconWrapper = ({
  children,
  className,
  position,
}: {
  children: React.ReactNode
  className?: string
  position: "left" | "right"
}) => (
  <div
    className={cx(styles.iconWrapper, className, {
      [styles.iconLeft]: position === "left",
      [styles.iconRight]: position === "right",
    })}
  >
    {children}
  </div>
)

export const BaseField = ({ label, errorText, children, required, disabled, id }: TextFieldProps) => {
  return (
    <div className={styles.container}>
      {label && <Label label={label} id={id} required={required} disabled={disabled} />}
      <div className={styles.inputWrapper}>{children}</div>
      {errorText && <small className={styles.errorText}>{errorText}</small>}
    </div>
  )
}
